module.exports = __webpack_public_path__ + "img/online-calendar-animate.7ec5667f.svg";